import {DataStatus} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {useGetMobileDePlatformQuery, useMobileDeAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormMobileDe,
  PlatformAuthenticationFormMobileDeProps,
} from './components/PlatformAuthenticationFormMobileDe';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsMobileDe() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetMobileDePlatformQuery({params});
  const [saveAuthentication] = useMobileDeAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormMobileDeProps['onSubmit'] = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && (
          <PlatformAuthenticationFormMobileDe
            defaultValues={data.credentials}
            onSubmit={onSubmitCredentials}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MOBILE_DE} />
      </DataStatus>
    </Show>
  );
}
